import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/varsha_karada/" className="home__social-icon" target="_blank">
            <i className="uil uil-instagram"></i>
        </a>

        <a href="https://www.linkedin.com/in/varsha-karada/" className="home__social-icon" target="_blank">
        <i class="uil uil-linkedin-alt"></i>
        </a>

        <a href="https://github.com/VARSHA-442" className="home__social-icon" target="_blank">
            <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social
